import React from 'react';
import {
  bool,
  arrayOf,
  number,
  shape,
  string
} from 'prop-types';
import '../buybox.scss';

const ExcludeShippingStates = ({ fulfillment, availabilityType }) => {
  const { excludedShipStates, bossExcludedShipStates } = fulfillment || {};
  const { type } = availabilityType;
  const hasSameSthBossExcludeStates = () => {
    if (excludedShipStates || bossExcludedShipStates) {
      return excludedShipStates === bossExcludedShipStates;
    }
    return false;
  };
  if (type !== 'Shared' && type !== 'Online') {
    return null;
  }
  return (
    <div className="exclude__shipping--states">
      {hasSameSthBossExcludeStates() && (
        <div className="exclude__shipping--states-wrapper">
          <span className="icon-not--available icon-no--sth" />
          <span className="icon-not--available icon-no--boss" />
          <span className="shipping__states--message">
            {`We're unable to ship this item to homes and stores in: ${excludedShipStates}`}
          </span>
        </div>
      )}
      {!hasSameSthBossExcludeStates() && excludedShipStates && (
        <div className="exclude__shipping--states-wrapper">
          <span className="icon-not--available icon-no--sth" />
          <span className="shipping__states--message">
            {`We're unable to ship this item to homes in: ${excludedShipStates}`}
          </span>
        </div>
      )}
      {!hasSameSthBossExcludeStates() && bossExcludedShipStates && (
        <div className="exclude__shipping--states-wrapper">
          <span className="icon-not--available icon-no--boss" />
          <span className="shipping__states--message">
            {`We're unable to ship this item to stores in: ${bossExcludedShipStates}`}
          </span>
        </div>
      )}
    </div>
  );
};

ExcludeShippingStates.propTypes = {
  fulfillment: shape({
    excludedShipStates: string,
    bossExcludedShipStates: string
  }),
  availabilityType: shape({
    type: string
  })
};

ExcludeShippingStates.defaultProps = {
  fulfillment: null,
  availabilityType: null
};

export { ExcludeShippingStates };
